export interface Complain {
  eventId: string;
  submitId: string;
  status: ComplainStatus;
  storeId: string;
  escalate: string;
  reason?: string;
  visitDate: string;
}

export interface UpdateComplainParam {
  eventId: string;
  submitId: string;
  status?: ComplainStatus;
  details?: string;
  escalate?: string;
  reason?: string;
}

export enum ComplainStatus {
  open = "open",
  viewed = "viewed",
  inProgress = "inProgress",
  closed = "closed",
}

export interface ComplainLog {
  username: string;
  createdAt: string;
  statusFrom?: ComplainStatus;
  statusTo?: ComplainStatus;
  details?: string;
  escalate?: string;
  reason?: string;
}
